import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { fetchNotices } from "./asyncActions";
import { INoticesState, INotice } from "./types";

const initialState: INoticesState = {
  notices: [],
  isLoading: false,
};

const noticesSlice = createSlice({
  name: "notices",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchNotices.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(
      fetchNotices.fulfilled,
      (state, action: PayloadAction<INotice[] | null>) => {
        state.isLoading = false;
        // null — запрос не удался, оставляем то, что было
        if (action.payload) {
          state.notices = action.payload;
        }
      }
    );
    builder.addCase(fetchNotices.rejected, (state) => {
      state.isLoading = false;
    });
  },
});

export default noticesSlice.reducer;
